import { useQuery } from '../../utils';
import ServiceConfigs from '../../config';
import { voucherDetailsQuery } from '../../queries';
import { QueryHookResponse } from '../../types/internal';
import { Voucher } from '../../types/generated';

type useVouchersType = ({ initialData, code }?: { initialData?: Voucher; code?: string }) => QueryHookResponse<Voucher>;

const useVoucherDetails: useVouchersType = ({ initialData, code } = {}) =>
  useQuery<Voucher>({
    query: voucherDetailsQuery,
    variables: code ? { subdomain: ServiceConfigs.getSubDomain(), code } : null,
    handler: (res: any) => res?.store.voucher,
    config: { initialData },
  });

export default useVoucherDetails;
